export enum ExpertiseEndpoints {
	FetchExpertises = '/expertises',
}
